import Vue from 'vue'
import Router from 'vue-router'
import NProgress from 'nprogress'
import store from './store/store'
import NetworkIssue from './views/NetworkIssue.vue'
import moment from 'moment'

Vue.use(Router)
const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/register',
      name: 'register',
      component: resolve => require([`@/views/Register`], resolve),
      beforeEnter(to, from, next) {
        const loggedIn = localStorage.getItem('user')
        if (loggedIn) {
          next('/')
        }
        getCustomTheme(next)
      }
    },
    {
      path: '/sign-in',
      name: 'sign-in',
      component: resolve => require([`@/views/SignIn`], resolve),
      beforeEnter(to, from, next) {
        const loggedIn = localStorage.getItem('user')
        if (loggedIn) {
          next('/')
        }
        getCustomTheme(next)
      }
    },
    {
      path: '/verify-invitation',
      name: 'verify-invitation',
      component: resolve => require([`@/views/VerifyInvitation`], resolve),
      beforeEnter(to, from, next) {
        getCustomTheme(next)
      }
    },
    {
      path: '/',
      name: 'home',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: resolve => require([`@/components/layout/layout`], resolve),
      children: [
        {
          path: '/',
          component: resolve => require([`@/views/Home.vue`], resolve),
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/dashboard/landing',
          component: resolve =>
            require([`@/views/DashboardLanding.vue`], resolve),
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/dashboard',
          component: resolve => require([`@/views/Dashboard.vue`], resolve),
          meta: {
            requireAuth: true,
            permissions: ['Dashboard Module.View']
          }
        },
        {
          path: '/patients',
          component: resolve => require([`@/views/Patients.vue`], resolve),
          meta: {
            requireAuth: true,
            permissions: [
              'Patients.Monitor.View',
              'Patients.Charts Module.Voiding Chart.View',
              'Patients.Charts Module.Event Chart.View',
              'Patients.Charts Module.Pad Fill Profile Chart.View',
              'Patients.Charts Module.Smartz Devices Chart.View',
              'Patients.Charts Module.Body Position Chart.View',
              'Patients.Goals Module.Pad Fill Profile.View',
              'Patients.Goals Module.Skin Care.View',
              'Patients.Goals Module.Position.View',
              'Patients.Goals Module.Temperature.View',
              'Patients.Goals Module.Fall.View'
            ]
          },
          children: [
            {
              path: '/patients/landing',
              component: resolve =>
                require([`@/views/patients/PatientLandingPage.vue`], resolve),
              meta: {
                requireAuth: true,
                permissions: [
                  'Dashboard Module.Individual.View',
                  'Patients.Monitor.View',
                  'Patients.Charts Module.Voiding Chart.View',
                  'Patients.Charts Module.Event Chart.View',
                  'Patients.Charts Module.Pad Fill Profile Chart.View',
                  'Patients.Charts Module.Smartz Devices Chart.View',
                  'Patients.Charts Module.Body Position Chart.View',
                  'Patients.Goals Module.Pad Fill Profile.View',
                  'Patients.Goals Module.Skin Care.View',
                  'Patients.Goals Module.Position.View',
                  'Patients.Goals Module.Temperature.View',
                  'Patients.Goals Module.Fall.View'
                ]
              }
            },
            {
              path: '/patients/monitor',
              component: resolve =>
                require([`@/views/patients/Monitor.vue`], resolve),
              meta: {
                requireAuth: true,
                permissions: ['Patients.Monitor.View']
              }
            },
            {
              path: '/patients/voiding-chart',
              component: resolve =>
                require([`@/views/patients/VoidingChart.vue`], resolve),
              meta: {
                requireAuth: true,
                permissions: ['Patients.Charts Module.Voiding Chart.View']
              }
            },
            {
              path: '/patients/smartz-events-chart',
              component: resolve =>
                require([`@/views/patients/SmartzEventsChart.vue`], resolve),
              meta: {
                requireAuth: true,
                permissions: ['Patients.Charts Module.Event Chart.View']
              }
            },
            {
              path: '/patients/pad-fill-profile-chart',
              component: resolve =>
                require([`@/views/patients/PadFillProfileChart.vue`], resolve),
              meta: {
                requireAuth: true,
                permissions: [
                  'Patients.Charts Module.Pad Fill Profile Chart.View'
                ]
              }
            },
            {
              path: '/patients/position-chart',
              component: resolve =>
                require([`@/views/patients/PositionChart.vue`], resolve),
              meta: {
                requireAuth: true,
                permissions: ['Patients.Charts Module.Body Position Chart.View']
              }
            },
            {
              path: '/patients/smartz-devices',
              component: resolve =>
                require([`@/views/patients/SmartzDevices.vue`], resolve),
              meta: {
                requireAuth: true,
                permissions: [
                  'Patients.Charts Module.Smartz Devices Chart.View'
                ]
              }
            },
            {
              path: '/patients/pad-fill-profile-goal',
              component: resolve =>
                require([`@/views/patients/goal/PadFillProfile.vue`], resolve),
              meta: {
                requireAuth: true,
                permissions: ['Patients.Goals Module.Pad Fill Profile.View']
              }
            },
            {
              path: '/patients/skin-care-goal',
              component: resolve =>
                require([`@/views/patients/goal/SkinCare.vue`], resolve),
              meta: {
                requireAuth: true,
                permissions: ['Patients.Goals Module.Skin Care.View']
              }
            },
            {
              path: '/patients/position-goal',
              component: resolve =>
                require([`@/views/patients/goal/Position.vue`], resolve),
              meta: {
                requireAuth: true,
                permissions: ['Patients.Goals Module.Position.View']
              }
            },
            {
              path: '/patients/temperature-goal',
              component: resolve =>
                require([`@/views/patients/goal/Temperature.vue`], resolve),
              meta: {
                requireAuth: true,
                permissions: ['Patients.Goals Module.Temperature.View']
              }
            },
            {
              path: '/patients/fall-detection-goal',
              component: resolve =>
                require([`@/views/patients/goal/Falls.vue`], resolve),
              meta: {
                requireAuth: true,
                permissions: ['Patients.Goals Module.Fall.View']
              }
            }
          ]
        },
        {
          path: '/manage',
          component: resolve => require([`@/views/Manage.vue`], resolve),
          meta: {
            requireAuth: true,
            permissions: [
              'Manage Module.Organisation.Buildings & Rooms.View',
              'Manage Module.Organisation.Manufacturers.View',
              'Manage Module.Organisation.Network Map.View',
              'Manage Module.Organisation.Settings.View',
              'Manage Module.Organisation.Roles & Permissions.View',
              'Manage Module.Organisation.Profile.Save',
              'Manage Module.Account.Save',
              'Manage Module.Account.Delete',
              'Manage Module.Users.User Accounts.View',
              'Manage Module.Users.Invite User.Save',
              'Manage Module.Patients.Patients Module.View',
              'Manage Module.Patients.Patient Data Privacy.Archive',
              'Manage Module.Patients.Patient Data Privacy.Restore',
              'Manage Module.Patients.Patient Data Privacy.Delete',
              'Manage Module.Devices.Nodes.View',
              'Manage Module.Devices.Pods Location.View',
              'Manage Module.Report.Export.Save',
              'Manage Module.Report.History.View',
              'Manage Module.Super Admin.Algorithms.View',
              'Manage Module.Super Admin.Data Privacy.Save',
              'Manage Module.Super Admin.Customisation.Save'
            ]
          },
          children: [
            {
              path: '/manage/landing',
              component: resolve =>
                require([`@/views/manage/ManageLanding.vue`], resolve),
              meta: {
                requireAuth: true,
                permissions: [
                  'Manage Module.Organisation.Buildings & Rooms.View',
                  'Manage Module.Organisation.Manufacturers.View',
                  'Manage Module.Organisation.Network Map.View',
                  'Manage Module.Organisation.Settings.View',
                  'Manage Module.Organisation.Roles & Permissions.View',
                  'Manage Module.Organisation.Profile.Save',
                  'Manage Module.Account.Save',
                  'Manage Module.Account.Delete',
                  'Manage Module.Users.User Accounts.View',
                  'Manage Module.Users.Invite User.Save',
                  'Manage Module.Patients.Patients Module.View',
                  'Manage Module.Patients.Patient Data Privacy.Archive',
                  'Manage Module.Patients.Patient Data Privacy.Restore',
                  'Manage Module.Patients.Patient Data Privacy.Delete',
                  'Manage Module.Devices.Nodes.View',
                  'Manage Module.Devices.Pods Location.View',
                  'Manage Module.Report.Export.Save',
                  'Manage Module.Report.History.View',
                  'Manage Module.Super Admin.Algorithms.View',
                  'Manage Module.Super Admin.Data Privacy.Save',
                  'Manage Module.Super Admin.Customisation.Save'
                ]
              }
            },
            {
              path: '/manage/data-privacy',
              component: resolve =>
                require([`@/views/manage/patients/DataPrivacy.vue`], resolve),
              meta: {
                requireAuth: true,
                permissions: [
                  'Manage Module.Patients.Patient Data Privacy.Archive',
                  'Manage Module.Patients.Patient Data Privacy.Restore',
                  'Manage Module.Patients.Patient Data Privacy.Delete'
                ]
              }
            },
            {
              path: '/manage/organisation-profile',
              component: resolve =>
                require([
                  `@/views/manage/organisation/OrganisationProfile.vue`
                ], resolve),
              meta: {
                requireAuth: true,
                permissions: ['Manage Module.Organisation.Profile.Save']
              }
            },
            {
              path: '/manage/buildings-rooms',
              component: resolve =>
                require([
                  `@/views/manage/organisation/BuildingsAndRooms.vue`
                ], resolve),
              meta: {
                requireAuth: true,
                permissions: [
                  'Manage Module.Organisation.Buildings & Rooms.View'
                ]
              }
            },
            {
              path: '/manage/manufacturers',
              component: resolve =>
                require([
                  `@/views/manage/organisation/Manufacturers.vue`
                ], resolve),
              meta: {
                requireAuth: true,
                permissions: ['Manage Module.Organisation.Manufacturers.View']
              }
            },
            {
              path: '/manage/network-map',
              component: resolve =>
                require([
                  `@/views/manage/organisation/NetworkMap.vue`
                ], resolve),
              meta: {
                requireAuth: true,
                permissions: ['Manage Module.Organisation.Network Map.View']
              }
            },
            {
              path: '/manage/network-utilisation',
              component: resolve =>
                require([
                  `@/views/manage/organisation/NetworkUtilisation.vue`
                ], resolve),
              meta: {
                requireAuth: true
              }
            },
            {
              path: '/manage/organisation-setting',
              component: resolve =>
                require([`@/views/manage/organisation/Setting.vue`], resolve),
              meta: {
                requireAuth: true,
                permissions: ['Manage Module.Organisation.Settings.View']
              }
            },
            {
              path: '/manage/my-account',
              component: resolve =>
                require([`@/views/manage/MyAccount.vue`], resolve),
              meta: {
                requireAuth: true,
                permissions: [
                  'Manage Module.Account.Save',
                  'Manage Module.Account.Delete'
                ]
              }
            },
            {
              path: '/manage/admin-permissions',
              component: resolve =>
                require([`@/views/manage/admin/AdminPermission.vue`], resolve),
              meta: {
                requireAuth: true,
                permissions: [
                  'Manage Module.Organisation.Roles & Permissions.View'
                ]
              }
            },
            {
              path: '/manage/admin-algorithms',
              component: resolve =>
                require([`@/views/manage/admin/AdminAlgorithms.vue`], resolve),
              meta: {
                requireAuth: true,
                permissions: ['Manage Module.Super Admin.Algorithms.View']
              }
            },
            {
              path: '/manage/admin-data-privacy',
              component: resolve =>
                require([`@/views/manage/admin/AdminDataPrivacy.vue`], resolve),
              meta: {
                requireAuth: true,
                permissions: ['Manage Module.Super Admin.Data Privacy.Save']
              }
            },
            {
              path: '/manage/admin-customization',
              component: resolve =>
                require([`@/views/manage/admin/Customization.vue`], resolve),
              meta: {
                requireAuth: true,
                permissions: ['Manage Module.Super Admin.Customisation.Save']
              }
            },
            {
              path: '/manage/user-accounts',
              component: resolve =>
                require([`@/views/manage/users/UserAccounts.vue`], resolve),
              meta: {
                requireAuth: true,
                permissions: ['Manage Module.Users.User Accounts.View']
              }
            },
            {
              path: '/manage/invite-user',
              component: resolve =>
                require([`@/views/manage/users/InviteUser.vue`], resolve),
              meta: {
                requireAuth: true,
                permissions: ['Manage Module.Users.Invite User.Save']
              }
            },
            {
              path: '/manage/patient-list',
              component: resolve =>
                require([`@/views/manage/patients/PatientList.vue`], resolve),
              meta: {
                requireAuth: true,
                permissions: ['Manage Module.Patients.Patients Module.View']
              }
            },
            {
              path: '/manage/report',
              component: resolve =>
                require([`@/views/manage/report/Report.vue`], resolve),
              meta: {
                requireAuth: true,
                permissions: ['Manage Module.Report.Export.Save']
              }
            },
            {
              path: '/manage/report-history',
              component: resolve =>
                require([`@/views/manage/report/ReportHistory.vue`], resolve),
              meta: {
                requireAuth: true,
                permissions: ['Manage Module.Report.History.View']
              }
            },
            {
              path: '/manage/devices-pods',
              component: resolve =>
                require([`@/views/manage/devices/Location.vue`], resolve),
              meta: {
                requireAuth: true,
                permissions: ['Manage Module.Devices.Pods Location.View']
              }
            },
            {
              path: '/manage/devices-nodes',
              component: resolve =>
                require([`@/views/manage/devices/NodeManagement.vue`], resolve),
              meta: {
                requireAuth: true,
                permissions: ['Manage Module.Devices.Nodes.View']
              }
            }
          ]
        },
        {
          path: '/404',
          name: '404',
          component: resolve => require([`@/views/NotFound.vue`], resolve)
        }
      ],
      beforeEnter(routeTo, routeFrom, next) {
        let tokenInfo = localStorage.getItem('tokenInfo')
          ? JSON.parse(localStorage.getItem('tokenInfo'))
          : null
        if (!tokenInfo) {
          window.localStorage.clear()
          router.push('/sign-in')
          return
        }
        if (routeFrom.path === '/sign-in' || routeFrom.path === '/register') {
          getCustomTheme(next)
          return
        } else {
          let expireDiff = moment
            .unix(tokenInfo.expires_on)
            .diff(moment(), 'minutes')
          if (expireDiff < 5 && !store.state.user.token_refreshing) {
            store
              .dispatch('user/refreshToken')
              .then(() => {
                getBasicInfo(next)
                return
              })
              .catch(() => {
                store.dispatch('user/logout')
              })
          } else {
            getBasicInfo(next)
            return
          }
        }
      },
      meta: { requiresAuth: true }
    },
    {
      path: '*',
      redirect: { name: '404' }
    },
    {
      path: '/network-issue',
      name: 'network-issue',
      component: NetworkIssue
    }
  ]
})

router.beforeEach((routeTo, routeFrom, next) => {
  NProgress.start()
  const loggedIn = localStorage.getItem('user')
  // If user don't login, site will directly jump to the sign in page
  if (routeTo.matched.some(record => record.meta.requiresAuth) && !loggedIn) {
    next('/sign-in')
  }

  // Whether the current user has permission to view the page
  if (
    routeTo.meta &&
    routeTo.meta.permissions &&
    routeTo.meta.permissions.length
  ) {
    let flag = false
    let permissions = JSON.parse(localStorage.getItem('permissions'))
    permissions.forEach(permission => {
      if (routeTo.meta.permissions.indexOf(permission) > -1) {
        flag = true
      }
    })
    if (!flag) {
      next('/404')
    }
  }

  next()
})

router.afterEach(() => {
  NProgress.done()
})

const getCustomTheme = function(next) {
  store
    .dispatch('customization/getCustomTheme')
    .then(response => {
      if (response instanceof Error) {
        next({ name: 'network-issue' })
      } else {
        next()
      }
    })
    .catch(() => next({ name: 'network-issue' }))
}

const getBasicInfo = function(next) {
  store
    .dispatch('customization/getCustomTheme')
    .then(response => {
      if (response instanceof Error) {
        next({ name: 'network-issue' })
      } else {
        store.dispatch('patient/fetchPatients').then(response => {
          if (response instanceof Error) {
            next({ name: 'network-issue' })
          } else {
            store.dispatch('filter/getUserFilter').then(() => {
              next()
            })
          }
        })
      }
    })
    .catch(() => next({ name: 'network-issue' }))
}

const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error)
}
export default router
